import ViewBase from "../../../../framework/core/mvvm/view_base";
import ModelData, { IUserData, HallShowGameData } from "../../../public/model_data";
import GameUtil from '../../../../utility/game_util';
import MarqueeComponent from "../marquee/marquee_component";
import HallGameIcon from "./hall_game_icon";
import LoaclStorage from "../../../../manager/local_storage";
import AppData from "../../../public/const/app_data";
import Utility from "../../../../utility/utility";
import { IUserCurrencyData } from "../../../../manager/user_manager";
import { DayWelFareComponent } from "../daywelfare/day_welfare_comp";
import PublicPlayerAvatar from "../../../public/component/public_player_avatar";


const { ccclass, property, menu } = cc._decorator;

@ccclass('PlayerInfo')
export class PlayerInfo {
    @property(PublicPlayerAvatar)
    avatar: PublicPlayerAvatar = null

    @property(cc.Label)
    id: cc.Label = null

    @property(cc.Label)
    daibi:cc.Label = null;

    @property(cc.Label)
    level: cc.Label = null

    @property(MarqueeComponent)
    marquee: MarqueeComponent = null;

    @property(cc.Node)
    expNode:cc.Node = null;

    @property(cc.Node)
    loginType:cc.Node[] = [];
}

@ccclass
@menu("package/hall/hall/hallView")
export default class HallView extends ViewBase {
    @property(PlayerInfo)
    playerInfo: PlayerInfo = new PlayerInfo()

    @property(cc.Node)
    nodeChipInfo: cc.Node = null

    @property(cc.Node)
    gameList: cc.Node[] = [];
    gameNameList: string[] = ["TM_LHD", "TM_DZPK", "TM_HJK", "TM_QZNN", "TM_QZNN", "disable"]
    gamePosList: cc.Vec2[] = []

    @property(cc.Node)
    moreNode: cc.Node = null;

    @property(cc.Node)
    gamesRoot: cc.Node = null

    @property(cc.Node)
    wideScreenAdapIcons: cc.Node[] = [];

    @property(cc.PageView)
    pageView: cc.PageView = null;

    @property(cc.Node)
    viewMask:cc.Node = null;

    @property(cc.SpriteAtlas)
    gameNamesAtlas: cc.SpriteAtlas = null

    @property(dragonBones.DragonBonesAsset)
    dragonAssets: dragonBones.DragonBonesAsset[] = []

    @property(dragonBones.DragonBonesAtlasAsset)
    dragonAtlasAssets: dragonBones.DragonBonesAtlasAsset[] = []

    @property(cc.Node)
    content: cc.Node = null

    @property(cc.Node)
    btnMore: cc.Node = null

    @property(cc.Node)
    firstChargeNode: cc.Node = null;

    @property(cc.Node)
    qucikBuyBtn:cc.Node = null;

    @property(cc.Node)
    nodeDailySignBtn: cc.Node = null

    @property(cc.Node)
    customerBtn: cc.Node = null

    @property(cc.Node)
    noticeBtn: cc.Node = null

    @property(cc.Node)
    shareBtn: cc.Node = null

    @property(cc.Node)
    nodePrant: cc.Node = null

    @property([cc.Node])
    chatChannels: cc.Node[] = [];

    @property(cc.Node)
    friendNode: cc.Node = null;

    @property(cc.Node)
    clubNode: cc.Node = null;

    @property(cc.Node)
    buttonADRewardGet: cc.Node = null;

    @property(DayWelFareComponent)
    daywelfareComp:DayWelFareComponent = null;

    private gamesItem:Map<string,HallGameIcon> = null;

    userLevel = 0

    pageNum = 6
    curPage = 0
    totalPage = 3

    private viewSize:cc.Size;

    iconPosArr: cc.Vec2[] = [
        new cc.Vec2(-419, 172.5),
        new cc.Vec2(-419, -172.5),
        new cc.Vec2(-27, 172.5),
        new cc.Vec2(-27, -172.5),
        new cc.Vec2(365, 172.5),
        new cc.Vec2(365, -172.5),]
    onLoad() {
        this.initGamePosList();
        this.initGamesItem()
        
        this.resizeHall()
    }

    onShow() {
        this.nodeChipInfo.active = ModelData.instance.showChipCurrency
        // this.playerInfo.gold.node.parent.active = ModelData.instance.showGoldCurrency

        if (AppData.startCheckGame) {
            this.customerBtn.active = false
            this.noticeBtn.active = false
            // this.buttonADRewardGet.active = false
            // this.nodePrant.active = false
            // this.nodePrant.getChildByName("miniRank").active = false
            this.clubNode.active = false
            //this.friendNode.active = false
        }
        this.updateGameInfo()
        // cc.systemEvent.on("canvas_resize", this.resizeHall.bind(this))
        if (!CC_DEBUG && (!CC_JSB || !Utility.version_judge(AppData.appVersion, "1.2.3"))) {
            this.buttonADRewardGet.active = false
        }
    }

    initGamesItem(){
        this.gamesItem = new Map<string,HallGameIcon>();
        for (let j = 0; j < this.gamesRoot.childrenCount; j++) {
            let childNode = this.gamesRoot.children[j];
            if (this.gamesItem) {
                this.gamesItem.set(childNode.name,childNode.getComponent(HallGameIcon));
            }
        }
        this.viewSize = this.viewMask.getContentSize();
    }

    resizeHall() {
        let showMoreBtn = !AppData.isWidescreen
        this.btnMore.active = showMoreBtn
        if (showMoreBtn) {
            let moreNodeParent = this.moreNode.getChildByName("moreBtns")
            for (let i = 0; i < this.wideScreenAdapIcons.length; i++) {
                // this.iphoneXModeIcon[i].active = !showMoreBtn
                this.wideScreenAdapIcons[i].parent = moreNodeParent
            }
        }
        if (AppData.isWidescreen) {
            this.viewMask.setContentSize(cc.size(this.viewSize.width+280,this.viewSize.height));
        }else{
            this.viewMask.setContentSize(this.viewSize);
        }
    }

    updateGameInfo(){
        let gameNames: HallShowGameData[] = ModelData.instance.gameDataShow
        let userLevel = ModelData.instance.roleData.userLevel
        for (let i = 0; i < gameNames.length; i++) {
            let gameInfo = gameNames[i];
            let gameItem = this.gamesItem.get(gameInfo.gameId);
            if (gameItem) {
                let lv = userLevel < gameInfo.openLevel ? gameInfo.openLevel : 0
                gameItem.updateLvLock(lv);
            }
        }
    }

    showGameIcon(isCheck: boolean) {
        let gameNames: HallShowGameData[] = ModelData.instance.gameDataShow
        this.hidePage(gameNames.length)

        let page = 0
        let pageNode = this.content.getChildByName("page_" + (page + 1))
        if (pageNode == null) {
            return
        }
        pageNode.active = true

        let childNode: cc.Node = null
        let childIndex = 0
        let dragonAssets
        let dragonAtlas
        let userLevel = ModelData.instance.roleData.userLevel
        for (let i = 0; i < gameNames.length; i++) {
            if (Math.floor(i / this.pageNum) > page) {
                childIndex = 0
                page = (Math.floor(i / this.pageNum))
                pageNode = this.content.getChildByName("page_" + (page + 1))
                pageNode.active = true;
                pageNode.parent = this.content
            }
            childNode = pageNode.children[childIndex]
            let gameId = gameNames[i].gameId
            childNode.name = gameId
            childNode.active = true;
            let gameIcon = childNode.getComponent(HallGameIcon)
            dragonAssets = this.getDragonAssets(gameId)
            dragonAtlas = this.getDragonAtlas(gameId)
            gameIcon.setName(gameId, dragonAssets, dragonAtlas, userLevel < gameNames[i].openLevel ? gameNames[i].openLevel : 0)
            childIndex++
        }
        this.addLockIcon(childIndex, pageNode, page)
    }

    hidePage(maxNodes: number) {
        // let nodeNum = 0;
        // for (let i = 0; i < this.pageNodes.length; i++) {
        //     nodeNum = (i + 1) * 6
        //     if (nodeNum - maxNodes >= 6) {
        //         let pageNode = this.pageNodes[i]
        //         this.pageView.removePage(pageNode)
        //     }
        // }
    }

    addLockIcon(childIndex: number, pageNode: cc.Node, pageNum: number) {
        let index = childIndex
        for (index; index < this.pageNum; index++) {
            pageNode.children[index].active = false
        }
        pageNum++
        return pageNum
    }

    setInfo(data: IUserData) {
        // cc.log("重新刷新人物相关信息:",data)
        this.playerInfo.avatar.maxNameCharLen = 10
        this.playerInfo.avatar.show(true, data.id)
        //测试账号ID与昵称都显示:guest333
        this.playerInfo.id.string = "ID:" + data.idShow
        let level = (data.userLevel && data.userLevel) < 1 ? 1 : data.userLevel
        if (this.userLevel != level) {
            this.updateGameInfo()
        }
        this.userLevel = level
        this.playerInfo.level.string = "LV." + level

        let thridType =  data.passportThridType 
        this.playerInfo.loginType[0].active = thridType == 2;
        this.playerInfo.loginType[1].active = thridType == 3;
        this.playerInfo.loginType[2].active = (thridType != 2 && thridType != 3);
        let total = (data.expNext == 0 || !data.expNext) ? 14:data.expNext;
        let cur = data.expCurrent ? data.expCurrent:0;
        let xsize = 245 * cur / total;
        this.playerInfo.expNode.setContentSize(xsize,30);

    }

    setCurrencyData(currencyData: IUserCurrencyData) {
        this.playerInfo.avatar.showCoinBalance(true)
        this.playerInfo.avatar.refreshCoinBalance(currencyData.chip)
        this.playerInfo.daibi.string = GameUtil.currencyFormatting(currencyData.daibi);
        // this.playerInfo.gold.string = GameUtil.currencyFormatting(currencyData.gold + currencyData.freez);
    }

    private initGamePosList() {
        this.gamePosList = [];
        for (let i = 0, len = this.gameList.length; i < len; i++) {
            let pos = this.gameList[i].getPosition();
            this.gamePosList.push(pos);
        }
    }
    getNodeByGameName(gameName: string) {
        let index = this.gameNameList.indexOf(gameName)
        cc.log("gameName:" + gameName + ",index:" + index)
        if (index != -1 && index < this.gameList.length) {
            return this.gameList[index]
        }
        return this.gameList[this.gameList.length - 1]
    }

    refreshGameView(refList) {
        let dataCount = refList.length
        for (let i = 0, len = this.gameList.length; i < len; i++) {
            this.gameList[i].active = false;
        }
        if (dataCount < this.gameList.length) {
            this.setGameData("disable", dataCount)
        }
        for (let i = 0; i < dataCount; i++) {
            let gameData = refList[i]
            this.setGameData(gameData.gameId, i)
        }
    }
    setGameData(gameName: string, index: number) {
        let node = this.getNodeByGameName(gameName)
        node.active = true;
        node.setPosition(this.gamePosList[index])
    }

    moveButton(move: string) {
        let pageNum = this.pageView.getCurrentPageIndex()
        if (move == "left") {

            if (pageNum == 0) {
                return
            }
            pageNum -= 1
            this.pageView.scrollToPage(pageNum, 0.5);

        } else if (move == "right") {

            if (pageNum == 4) {
                return
            }
            pageNum += 1
            this.pageView.scrollToPage(pageNum, 0.5);
        }
    }


    getDragonAssets(key: string) {
        key = key + "_ske"
        for (let i = 0; i < this.dragonAssets.length; i++) {
            if (this.dragonAssets[i].name == key) {
                return this.dragonAssets[i]
            }
        }
    }
    getDragonAtlas(key: string) {
        key = key + "_tex"
        for (let i = 0; i < this.dragonAtlasAssets.length; i++) {
            if (this.dragonAtlasAssets[i].name == key) {
                return this.dragonAtlasAssets[i]
            }
        }
    }


    showDailySignBtn(show: boolean) {
        this.nodeDailySignBtn.active = show

    }

    updateDayWelfare(data:any){
        this.daywelfareComp.updateDayWelfare(data,(type)=>{
            this.daywelfareComp.show();
            if (type == 2) {//活动已经完成
                this.daywelfareComp.hide();
            }
        })
    }

    showFriendRed(state : boolean){
        this.friendNode.getChildByName("redSprite").active = state;
    }

    // type : 0:无聊天 1:世界 2:好友
    updateRecentChat(recentData) {
        try {

            this.chatChannels.forEach((element)=>{
                element.active = false;
            })

            if (!recentData) {
                this.chatChannels[0].active = true;
                return;
            }

            let type : number = recentData.type;
            let content: string = recentData.content;
                
            this.chatChannels[type].active = true;
    
            if(Utility.isJSON(content)){
    
                let json = JSON.parse(content);
                content = json.content;
            }
    
            let contelt_label = this.chatChannels[type].getChildByName("content_label").getComponent(cc.Label);
            
            content = Utility.strClamp(recentData.name + ":" + content, 50,"..");  //16
            contelt_label.string = content;

        } catch (error) {
            cc.error(error)
        }
    }
}
